var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActual(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.8075 20.5869H12.8075C13.3575 20.5869 13.8075 21.0369 13.8075 21.5869C13.8075 22.1369 13.3575 22.5869 12.8075 22.5869H2.8075C2.2575 22.5869 1.8075 22.1369 1.8075 21.5869C1.8075 21.0369 2.2575 20.5869 2.8075 20.5869ZM6.04749 7.6569L8.87749 4.8269L21.6075 17.5569C22.3875 18.3369 22.3875 19.6069 21.6075 20.3869C20.8275 21.1669 19.5575 21.1669 18.7775 20.3869L6.04749 7.6569ZM14.5375 1.9969L17.3675 4.8269C18.1475 5.6069 18.1475 6.8769 17.3675 7.6569L15.9475 9.0769L10.2975 3.4169L11.7075 2.0069C12.4875 1.2169 13.7575 1.2169 14.5375 1.9969ZM4.6375 9.0669L10.2975 14.7269L8.8875 16.1369C8.1075 16.9169 6.83749 16.9169 6.0575 16.1369L3.2275 13.3069C2.4475 12.5269 2.4475 11.2569 3.2275 10.4769L4.6375 9.0669Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActual);
export default __webpack_public_path__ + "static/media/actual.597a0164ac31558ea1b37c95c6366d3a.svg";
export { ForwardRef as ReactComponent };